import { registerComponent } from '../app'
import { SELECT_SS_CATEGORY, DESELECT_SS_CATEGORY } from '../events'

const SSSelected = (scope, el) => {
	const props = {
		selectedClass: 'selected',
		openClass: 'open'
	}

	const els = {
		toggles: el.querySelectorAll('[data-toggle]')
	}

	const state = {
		selected: []
	}

	for (let i = 0; i < els.toggles.length; i++) {
		els.toggles[i].addEventListener('click', function() {
			el.classList.toggle(props.openClass)
		})
	}

	scope.on(SELECT_SS_CATEGORY, category => {
		if (state.selected.indexOf(category) == -1) {
			state.selected.push(category)
		}
		el.classList.add(props.selectedClass)
	})

	scope.on(DESELECT_SS_CATEGORY, category => {
		if (!category) {
			state.selected = []
			el.classList.remove(props.selectedClass)
			return
		}

		state.selected.splice(state.selected.indexOf(category), 1)
		if (!state.selected.length) {
			el.classList.remove(props.selectedClass)
		}
	})
}

registerComponent('ss-selected', SSSelected)
